// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"wn_a bih_b"};